import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPhotographers, getFoodsafeties } from '../../redux/actions/tools';
import Layout from '../../components/layout/Layout';
import MenuButton from '../../components/MenuButton';
import FoodSafety from '../../components/tools/FoodSafety';
import Photographer from '../../components/tools/Photographer';
import Knowledge from './Knowledge';
import { TOOL_CATEGORY_IDS } from '../../constants/knowledge-base';

const Tools = () => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState('');
  const { role } = useSelector((state) => state?.auth?.user);
  const selectedLanguage = useSelector((state) => state.app.selectedLanguage);
  const isAdmin = role === 'admin';

  const recipesId = TOOL_CATEGORY_IDS.get(`recipes-${selectedLanguage}`);
  const videosId = TOOL_CATEGORY_IDS.get(`videos-${selectedLanguage}`);

  useEffect(() => {
    setTab('');
    dispatch(getPhotographers());
    dispatch(getFoodsafeties());
  }, [dispatch]);

  return (
    <Layout active="tools">
      <div className="flex flex-row mx-12 mt-8">
        {isAdmin && (
          <>
            <MenuButton
              onClick={() => {
                setTab('foodsafety');
              }}
              active={tab === 'foodsafety'}
              title="Food Safety"
              visible="true"
            />
            <MenuButton
              onClick={() => {
                setTab('recipes');
              }}
              active={tab === 'recipes'}
              title="Recipes"
              visible="true"
            />
            <MenuButton
              onClick={() => {
                setTab('videos');
              }}
              active={tab === 'videos'}
              title="Videos"
              visible="true"
            />
          </>
        )}
        <MenuButton
          onClick={() => {
            setTab('photographer');
          }}
          active={tab === 'photographer'}
          title="Photographers"
          visible="true"
        />
      </div>
      {tab === 'foodsafety' && <FoodSafety />}
      {tab === 'recipes' && recipesId && <Knowledge onlyContent categoryId={recipesId} />}
      {tab === 'videos' && videosId && <Knowledge onlyContent categoryId={videosId} />}
      {tab === 'photographer' && <Photographer />}
    </Layout>
  );
};

export default Tools;
